/* eslint-disable camelcase */

import { analytics } from './analytics'
import { ANALYTICS_EVENTS, events } from './events'
import { registrationAnalyticsContextStore } from './registration-analytics-context'

const UNKNOWN_ERROR_MESSAGE = 'unknown'

export const logRegistrationErrorDialogView = (
  errorMessage?: string | null
) => {
  if (!registrationAnalyticsContextStore.getCurrent()) {
    return
  }

  const step = registrationAnalyticsContextStore.getCurrentStep()
  const normalizedMessage = errorMessage?.trim()
    ? errorMessage
    : UNKNOWN_ERROR_MESSAGE

  analytics.logEvent(
    events[ANALYTICS_EVENTS.REGISTRATION_ERROR_DIALOG_VIEW]({
      error_message: normalizedMessage,
      ...(step != null && { step }),
    })
  )
}
